(function () {
  var DEFAULT_TARGET_ID = 'recensioni-feedaty';

  // Apre il target se e' un <details> e tutti i <details> che lo contengono.
  // closest() include l'elemento stesso, quindi copre entrambi i casi:
  // target = l'accordion, oppure target = un nodo dentro l'accordion.
  function openAncestors(target) {
    var el = target;
    while (el) {
      var d = el.closest('details');
      if (!d) break;
      if (!d.open) d.open = true; // fa scattare 'toggle' -> monta il widget Feedaty
      el = d.parentElement;
    }
  }

  function scrollToTarget(targetId) {
    var target = document.getElementById(targetId);
    if (!target) return false;

    openAncestors(target);

    // Scrolla al frame successivo: l'apertura dell'accordion cambia il layout.
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return true;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.feedaty-stars-product');
    if (!trigger) return;

    var targetId = trigger.getAttribute('data-feedaty-target') || DEFAULT_TARGET_ID;
    if (!targetId) return;

    e.preventDefault();

    if (scrollToTarget(targetId)) return;

    // L'accordion potrebbe non essere ancora nel DOM: riprova brevemente
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (scrollToTarget(targetId) || attempts > 20) clearInterval(timer);
    }, 150);
  });
})();
